<template>
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <!-- Detail modal -> list -->
  <vue-final-modal
    v-for="(index, value) in modalDetail" :key="value"
    v-model="modalDetail[value]"
    classes="base-modal"
    :ssr="true"
    content-class="base-modal-dashboard-employee bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>
        {{
          (value == 'Waiting') ? 'All Waiting for Approval List' :
          (value == 'Approved') ? 'All Approved List' :
          (value == 'Rejected') ? 'All Rejected List' :
          ''
        }}
      </h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openModalList({type: value, state: false})"/>
    </div>

    <!-- Modal Content -->
    <div class="modal-content-dashboard-employee">
      <!-- <div v-else-if="(value == 'leaveBalance')" class="detail-remaining-content"> -->
      <div class="detail-remaining-content">
        <div v-if="objectDetail" class="detail-tree">
          <div v-if="objectDetail.length == 0" class="detail-tree-no">
            <p>No data!</p>
          </div>

          <div v-else v-for="parent in objectDetail" :key="parent" class="detail-tree-period">
            <div class="period-header">
              {{ parent.period ? parent.period : parent.year ? parent.year : '' }}
            </div>

            <div class="detail-tree-inherit">
              <div v-for="data in parent.list ? parent.list : parent.month ? parent.month : 0" :key="data" class="parent-tree-container">
                <div class="parent-tree-content">
                  <p v-if="data.sisa_cuti"><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.sisa_cuti }}</b></p>
                  <p v-else><b>{{ data.month_name }}</b></p>
                </div>

                <div
                  v-for="child in data.history_cuti ? data.history_cuti : data.data ? data.data : 0"
                  :key="child"
                  @click="openDetail(child)"
                  class="child-tree-container"
                  :class="{
                    'child-tree-yellow': ((child.state == 'Waiting for Approval')),
                    'child-tree-green': ((child.state == 'Approved')) || ((child.sign_type == '1') && data.history_cuti),
                    'child-tree-red': ((child.state == 'Rejected')) || ((child.sign_type == '-1') && data.history_cuti)
                  }"
                >
                  <p><b>{{ child.employee_name + ' (' + child.transaction_no + ')' }}</b></p>
                  <p>{{ child.info }}</p>
                  <p>{{ child.start_date ? formatDate('event', child.start_date, child.end_date) : child.created_at ? formatDate('date', child.created_at) : child.createdat ? formatDate('date', child.createdat) : '' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>

  <!-- Detail modal -> transaction -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-2/3 lg:w-1/2"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <div class="modal-head">
      <h1>Detail Transaction</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openDetail()" />
    </div>

    <div class="modal-content detail-content" style="background-color: white;">
      <HrreqleaveDetail :prop-class="detailData" @close-modal="openDetail()" @refresh-list="refreshData()" />
    </div>
  </vue-final-modal>

  <!-- Detail modal -->
  <vue-final-modal
    v-model="remainingModal"
    classes="base-modal"
    :ssr="true"
    content-class="relative h-10/12 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-9/12"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Remaining Leave Balance</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openModal()" />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <RmainingDetail :remaining-detail="remainingDetail" />
    </div>
  </vue-final-modal>

  <main-section>
    <div class="hrd-dashboard">
      <div class="leave-container">
        <div :class="(remainingData.child_total != 0) ? 'leave-approval-container-atasan' : 'leave-approval-container'">
          <!-- Leave Now -->
          <LeaveApproval v-if="(listTodayData.data && (remainingData.child_total != 0)) || (listTodayData.data && (remainingData.parent_total > 1))" :leave-type="'ListLeaveToday'" :is-loading="isLoading" :panel-data="listTodayData.data" :leave-data="remainingAllData" @refresh-data="getData()" />

          <!-- Approval leave - Waiting panel -->
          <LeaveApproval v-if="waitingData.data" :leave-type="'Waiting'" :is-loading="isLoading" :panel-data="waitingData.data" :panel-datafull="waitingData.data_full" :leave-data="remainingAllData" @refresh-data="getData()" />

          <!-- Approval leave - Approved panel -->
          <LeaveApproval v-if="acceptData.data" :leave-type="'Approved'" :is-loading="isLoading" :panel-data="acceptData.data" :panel-datafull="acceptData.data_full" :leave-data="remainingAllData" @refresh-data="getData()" @open-all="openModalList($event)" />

          <!-- Approval leave - Rejected panel -->
          <LeaveApproval v-if="rejectData.data" :leave-type="'Rejected'" :is-loading="isLoading" :panel-data="rejectData.data" :panel-datafull="rejectData.data_full" :leave-data="remainingAllData" @refresh-data="getData()" @open-all="openModalList($event)" />
        </div>

        <div class="leave-personal-container">
          <!-- Remaining leave panel -->
          <!-- <LeaveRemaining v-if="checkUser" :is-loading="isLoading" :list-retirement="listEmployeeRetirement" /> -->
          <LeaveRemaining
            v-if="(remainingData.child_total != 0) || ['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles)"
            :is-loading="isLoading"
            :list-retirement="listEmployeeRetirement"
          />

          <!-- <LeaveRemaining v-if="checkUser" :is-loading="isLoading" :list-retirement="listEmployeeRetirement" /> -->

          <!-- Remaining leave panel -->
          <!-- <LeaveRemaining v-if="(remainingData.data) && ['ROLE_ADMIN,', 'ROLE_ADMIN'].includes(roles)" :is-loading="isLoading" :data-remaining="remainingData.child" @open-remaining="openModal('remaining', $event)" /> -->
          <LeaveRemaining
            v-if="(remainingData.child_total != 0) || ['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles)"
            :is-loading="isLoading"
            :show-filter="true"
            :list-active="prevEmployee.list_active"
            :data-remaining="remainingData.child ? remainingData.child : remainingData.parent"
            @open-remaining="openModal('remaining', $event)"
            @open-employee="openEmployee($event)"
          />

          <!-- <LeaveRemaining :is-loading="isLoading" :data-remaining="remainingData.filter(item => item.id != employeeId)[0]" @open-remaining="openModal('remaining', $event)" /> -->

          <!-- Personal leave panel -->
          <LeavePersonal
            :is-loading="isLoading"
            :check-child="remainingData"
            :employee-show="prevEmployee.check"
            :data-personal="profileData"
            :data-leave="profileLeaveAll"
            :data-annual="profileLeaveAnnual"
            :data-history="profileLeave"
            @open-remaining="openModal('remaining', $event)"
          />
            <!--
            :data-remaining="profileLeaveAll"
            :data-history="historyData"
            :data-remaining="remainingData"
            -->
        </div>

        <div v-if="['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles)" class="leave-group-container">
          <LeaveApproval :leave-type="'PanelGroup'" :is-loading="isLoading" :panel-data="groupPanel" @refresh-data="getExpiredEmployee()" />

          <!-- List Employee Expired -->
          <!-- <LeaveApproval :leave-type="'ExpiredEmployee'" :is-loading="isLoading" :panel-data="expiredEmployeeData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Employee Expiring -->
          <!-- <LeaveApproval :leave-type="'ExpiringEmployee'" :is-loading="isLoading" :panel-data="expiringEmployeeData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Document Expired -->
          <!-- <LeaveApproval :leave-type="'ExpiredDocument'" :is-loading="isLoading" :panel-data="expiredDocumentData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Document Expiring -->
          <!-- <LeaveApproval :leave-type="'ExpiringDocument'" :is-loading="isLoading" :panel-data="expiringDocumentData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Addition Expired -->
          <!-- <LeaveApproval :leave-type="'ExpiredAddition'" :is-loading="isLoading" :panel-data="expiredAdditionData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Addition Expiring -->
          <!-- <LeaveApproval :leave-type="'ExpiringAddition'" :is-loading="isLoading" :panel-data="expiringAdditionData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Addition Expired -->
          <!-- <LeaveApproval :leave-type="'ExpiredCareer'" :is-loading="isLoading" :panel-data="expiringCareerData" @refresh-data="getExpiredEmployee()" /> -->

          <!-- List Addition Expiring -->
          <!-- <LeaveApproval :leave-type="'ExpiringCareer'" :is-loading="isLoading" :panel-data="expiredCareerData" @refresh-data="getExpiredEmployee()" /> -->
        </div>
      </div>
    </div>
  </main-section>
</template>

<script>
/* eslint-disable */
import { ref, onMounted, onBeforeMount, computed, watchEffect, reactive } from 'vue'
import { useStore } from 'vuex'
import { mdiCheckBold, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
import { useRouter } from 'vue-router'
import axios from 'axios'

import 'vue-loading-overlay/dist/vue-loading.css'
import Loading from 'vue-loading-overlay'
import MainSection from '@/components/MainSection'
import CardBoxNotifLeave from '@/components/CardBoxNotifLeave'
import Field from '@/components/Field'
import JbButton from '@/components/JbButton'
import CryptoJS from 'crypto-js'

import LeavePersonal from './LeavePersonal.vue'
import LeaveApproval from './LeaveApproval.vue'
import LeaveRemaining from './LeaveRemaining.vue'
import RmainingDetail from '@/views/humanresource/hrreqleave/RmainingDetail.vue'
import HrreqleaveDetail from '@/views/humanresource/hrreqleave/Detail'

export default {
  name: 'Dashboard Leave',
  components: {
    MainSection,
    CardBoxNotifLeave,
    Field,
    JbButton,
    Loading,
    LeavePersonal,
    LeaveApproval,
    LeaveRemaining,
    RmainingDetail,
    HrreqleaveDetail
  },

  data () {
    return {
    }
  },

  emits: ['close-modal', 'submit'],

  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Dashboard'])
    const store = useStore()
    const darkMode = computed(() => store.state.darkMode)
    const isLoading = ref(false)
    const userLogin = localStorage.getItem('name')
    const employeeId = localStorage.getItem('employee_id')
    const userId = localStorage.getItem('user_id')
    const branchId = localStorage.getItem('branch_id')
    const roles = localStorage.getItem('roles')
    const usernameLogin = localStorage.getItem('username')
    const schoolidentity = reactive({
      file_name: ''
    })


    const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
    const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
    const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
    const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

    function formatDate(type, date, dateSec) {
      const start = new Date(date)
      const end = new Date(dateSec)

      const day = start.getDate()
      const month = start.getMonth()
      const year = start.getFullYear()
      const dayOfWeek = start.getDay()

      // const months = locale.value == 'id' ? monthsId : monthsEn
      // const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
      // const days = locale.value == 'id' ? daysId : daysEn
      // const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

      if(type == 'dateTime') {
        return `${daysEn[dayOfWeek]}, ${day} ${monthsEn[month]} ${year}`
      }
      else if(type == 'monthYear') {
        return `${monthsEn[month]} ${year}`
      }
      else if(type == 'month') {
        return `${monthsEn[month]}`
      }
      else if(type == 'monthNum') {
        return `${month}`
      }
      else if(type == 'date') {
        return `${day} ${monthsEn[month]} ${year}`
      }
      else if(type == 'day') {
        return `${day}`
      }
      else if (type == 'event') {
        const endDay = end.getDate()
        const endMonth = end.getMonth()
        const endYear = end.getFullYear()

        const startTime = start.toLocaleTimeString('id-ID', {
          hour: '2-digit', minute: '2-digit', hour12: false
        }).replace(":", ".")

        const endTime = end.toLocaleTimeString('id-ID', {
          hour: '2-digit', minute: '2-digit', hour12: false
        }).replace(":", ".")

        const isZeroTime = startTime === "00.00" && endTime === "00.00"
        const timeRange = isZeroTime ? "" : ` (${startTime} - ${endTime})`

        if (day === endDay && month === endMonth && year === endYear) {
          return `${days[dayOfWeek]}, ${day} ${monthsShort[month]} ${year}${timeRange}`
        } else if (month === endMonth && year === endYear) {
          return `${day} - ${endDay} ${monthsShort[month]} ${year}${timeRange}`
        } else {
          return `${day} ${monthsShort[month]} - ${endDay} ${monthsShort[endMonth]} ${endYear}${timeRange}`
        }
      }
    }


    const historyData = ref([])
    // const waitingData = ref({
    //   data: [],
    //   data_full: [],
    //   data_total: 0
    // })
    // const acceptData = ref({
    //   data: [],
    //   data_full: [],
    //   data_total: 0
    // })
    // const rejectData = ref({
    //   data: [],
    //   data_full: [],
    //   data_total: 0
    // })
    const waitingData = reactive({
      data: [],
      data_full: [],
      data_total: 0
    })
    const acceptData = reactive({
      data: [],
      data_full: [],
      data_total: 0
    })
    const rejectData = reactive({
      data: [],
      data_full: [],
      data_total: 0
    })
    const remainingData = reactive({
      data: {},
      parent: [],
      parent_total: 0,
      child: [],
      child_total: 0
    })
    const remainingChild = ref([])
    const remainingAllData = ref([])
    const listTodayData = reactive({
      data: [],
      data_total: 0
    })
    const listEmployeeRetirement = ref([])
    const getData = async () => {
      isLoading.value = true

      const thisDate = new Date()
      let thisYear = thisDate.getFullYear()
      let thisMonth = ('0' + (thisDate.getMonth() + 1)).slice(-2)
      const monthNow = (thisYear + '-' + thisMonth)

      const headers = {'Content-Encoding': 'gzip'}
      const params1 = {username: usernameLogin}
      const params2 = {username: usernameLogin, is_all: true}
      const params3 = {user_id: userId, employee_id: (employeeId != 'null') ? employeeId : null }
      const params4 = {employee_id: employeeId}
      const paramsLeaveWaiting = {
        username: usernameLogin,
        is_personal: 0,
        year: null,
        month: null
      }
      const paramsLeaveFull = {
        username: usernameLogin,
        is_all: true,
        is_personal: 0,
        year: null,
        month: null
      }

      try {
        const [response1, response2, response3, response4, response5, response6] = await Promise.all([
          axios.get("get-leave-notif", { headers, params: paramsLeaveWaiting }),
          axios.get("get-leave-notif", { headers, params: paramsLeaveFull }),
          axios.get("get-leave-history", { headers, params: params3 }),
          axios.get("get-leave-all-history", { headers, params: params3 }),
          axios.get("hrleave-employee", { headers }),
          axios.get("get-employee-retirement", { headers })
        ])

        if(response1.data.data) {
          const preData = response1.data.data
          const prevData = []

          // console.log("cek data waiting", preData)

          for (const [index, value] of Object.entries(preData)) {
            const formatLoop = value
            formatLoop['forFormatDate'] = value.createdat

            prevData.push(formatLoop)
          }

          waitingData.data_full = prevData
          waitingData.data = waitingData.data_full ? waitingData.data_full : []
          waitingData.data_total = waitingData.data ? waitingData.data.length : 0

          // console.log("cek notif waiting",  waitingData.data_full, waitingData.data, waitingData.data_total)
          // console.log("cek notif accept", acceptData.data_full, acceptData.data, acceptData.data_total)
          // console.log("cek notif reject",  rejectData.data_full, rejectData.data, rejectData.data_total)
        }

        if(response2.data.data) {
          const preData = response2.data.data
          const prevData = []

          // console.log("cek data approved/rejected", preData)

          for (const [index, value] of Object.entries(preData)) {
            const formatLoop = value
            formatLoop['forFormatDate'] = value.createdat

            prevData.push(formatLoop)
          }

          // waitingData.data_full = prevData.filter(item => item.state == "Waiting for Approval")
          // waitingData.data = waitingData.data_full ? waitingData.data_full : []
          // waitingData.data_total = waitingData.data ? waitingData.data.length : 0

          acceptData.data_full = prevData.filter(item => item.state == "Approved")
          acceptData.data = acceptData.data_full ? acceptData.data_full.slice(0, 10) : []
          acceptData.data_total = acceptData.data ? acceptData.data.length : 0

          rejectData.data_full = prevData.filter(item => item.state == "Rejected")
          rejectData.data = rejectData.data_full ? rejectData.data_full.slice(0, 10) : []
          rejectData.data_total = rejectData.data ? rejectData.data.length : 0

          // console.log("cek notif waiting",  waitingData.data_full, waitingData.data, waitingData.data_total)
          // console.log("cek notif accept", acceptData.data_full, acceptData.data, acceptData.data_total)
          // console.log("cek notif reject",  rejectData.data_full, rejectData.data, rejectData.data_total)
        }

        if(response3.data.data) {
          const backData = response3.data.data
          const prevData = []

          for (const [index, value] of Object.entries(response3.data.data)) {
            const grouped = backData.reduce((acc, item) => {
              if (!acc[item.period]) {
                acc[item.period] = []
              }
              acc[item.period].push(item)
              return acc
            }, {})

            const result = Object.keys(grouped)
              .sort((a, b) => b - a)
              .map(period => ({period, list: grouped[period].filter(item => item.id == value.id)[0].list_leave}))
            value['list_period'] = result

            prevData.push(value)
          }

          if(prevData) {
            remainingData.parent = prevData ? prevData : []
            remainingData.parent_total = remainingData.parent ? remainingData.parent.length : 0
            remainingData.data = prevData[0] ? prevData[0] : {}
            remainingData.child = remainingData.data ? remainingData.data.child_list : []
            remainingData.child_total = remainingData.child ? remainingData.child.length : 0

            listTodayData.data = response3.data.list_today ? response3.data.list_today : []
            listTodayData.data_total = listTodayData.data ? listTodayData.data.length : 0

            // console.log("cek remaining prev", remainingData.parent)
            // console.log("cek remaining data", remainingData.data)
            // console.log("cek remaining child", remainingData.child, remainingData.child_total)
            // console.log("cek list today", listTodayData.data, listTodayData.data_total)
          }
        }

        if(response4.data.data) {
          historyData.value = response4.data.data
          // console.log("cek history", response4.data.data)
        }

        if(response5.data.data) {
          remainingAllData.value = response5.data.data
          // console.log("cek all leave", response5.data.data)
          isLoading.value = false
        }

        if(response6.data.data) {
          listEmployeeRetirement.value = response6.data.data
          // console.log("cek data retirement", listEmployeeRetirement.value)
          isLoading.value = false
        }
      }
      catch(error) {
        console.log(error)
      }
    }


    const profileData = ref({})
    const profileLeaveAll = ref([])
    const profileLeaveAnnual = ref([])
    const profileLeave = ref([])
    const getProfile = async (id) => {
      const headers = {'Content-Encoding': 'gzip'}
      const params1 = {employee_id: id}
      const params2 = {user_id: userId, branch_id: branchId}

      try {
        const [response1, response2, response3] = await Promise.all([
          axios.get("employee", { headers, params: params2 }),
          axios.get("get-leave-all-history", { headers, params: params1 }),
          axios.get("get-leave-history", { headers, params: params1 }),
          // axios.get("get-photo-employee", { headers, params: params2 })
        ])

        if(response1.data.data) {
          profileData.value = response1.data.data[0]
          // console.log("cek data profile", response1.data.data, profileData.value)
        }

        if(response2.data.data) {
          const prevData = response2.data.data
          const preData = []

          for (const [index, value] of Object.entries(prevData)) {
            const loopData = value
            loopData['transaction_date'] = formatDate('date', value.transaction_date)
            loopData['updated_by'] = ((value.state == "Approved") || (value.state == "Rejected") ? value.updated_by : "")

            preData.push(loopData)
          }

          profileLeaveAll.value = preData
          profileLeaveAnnual.value = preData.filter(item => item.type == "Annual Leave")
          // console.log("cek employee leave history", profileLeaveAnnual.value, profileLeaveAll.value)
        }

        if(response3.data.data) {
          const prevData = response3.data.data

          if(prevData.length != 0) {
            profileLeave.value = prevData[0].list_leave
            // console.log("cek employee leave", profileLeave.value)
          }
        }

        // console.log("cek profile", response2.data)

        // if(response2.data.data) {
        //   profileData.value = response2.data.data
          // console.log("cek foto profile", response2.data.data)
        // }
      }
      catch(error) {
        console.log(error)
      }
    }

    // Check Role User
    const userRole = localStorage.getItem('roles')
    const checkUser = ref(false)
    const userCheck = async () => {
      if (userRole !== null) {
        const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
        const myArray = decryptedMessage.split(',')
        if (decryptedMessage === 'ROLE_ADMIN' || decryptedMessage === 'ROLE_ADMIN_HRD') { checkUser.value = true }
        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') { checkUser.value = true }
        }
      }
    }


    const groupPanel = ref([])

    // Expired Employee
    const expiredEmployeeData = ref([])
    const expiringEmployeeData = ref([])
    const expiredDocumentData = ref([])
    const expiringDocumentData = ref([])
    const expiredAdditionData = ref([])
    const expiringAdditionData = ref([])
    const expiringCareerData = ref([])
    const expiredCareerData = ref([])
    const getExpiredEmployee = async () => {
      isLoading.value = true

      const headers = {'Content-Encoding': 'gzip'}
      const params1 = {user_id: userId}

      try {
        const [response1] = await Promise.all([
          axios.get("get-list-expired-employee", { headers, params: params1 }),
        ])

        if(response1.data) {
          expiringDocumentData.value = response1.data.dataTrainingDocExpiring
          expiredDocumentData.value = response1.data.dataTrainingDocExpired
          expiringAdditionData.value = response1.data.dataLeaveAdditionExpiring
          expiredAdditionData.value = response1.data.dataLeaveAdditionExpired
          expiringEmployeeData.value = response1.data.dataContractExpiring
          expiredEmployeeData.value = response1.data.dataContractExpired
          expiringCareerData.value = response1.data.dataCareerPathExpiring
          expiredCareerData.value = response1.data.dataCareerPathExpired

          // console.log("cek expiringDocumentData", expiringDocumentData.value)
          // console.log("cek expiredDocumentData", expiredDocumentData.value)
          // console.log("cek expiringAdditionData", expiringAdditionData.value)
          // console.log("cek expiredAdditionData", expiredAdditionData.value)
          // console.log("cek expiringEmployeeData", expiringEmployeeData.value)
          // console.log("cek expiredEmployeeData", expiredEmployeeData.value)
          // console.log("cek expiringCareerData", expiringCareerData.value)
          // console.log("cek expiredCareerData", expiredCareerData.value)

          groupPanel.value = [
            {
              parent_id: "Contract",
              title: "Contract",
              child: [
                {
                  child_id: "ExpiringContract",
                  title: "Is Expiring",
                  color: "yellow",
                  data: expiringEmployeeData.value
                },
                {
                  child_id: "ExpiredContract",
                  title: "Is Expired",
                  color: "red",
                  data: expiredEmployeeData.value
                }
              ]
            },
            {
              parent_id: "Document",
              title: "Document",
              child: [
                {
                  child_id: "ExpiringDocument",
                  title: "Is Expiring",
                  color: "yellow",
                  data: expiringDocumentData.value
                },
                {
                  child_id: "ExpiredDocument",
                  title: "Is Expired",
                  color: "red",
                  data: expiredDocumentData.value
                }
              ]
            },
            {
              parent_id: "Leave",
              title: "Leave",
              child: [
                {
                  child_id: "ExpiringLeave",
                  title: "Is Expiring",
                  color: "yellow",
                  data: expiringAdditionData.value
                },
                {
                  child_id: "ExpiredLeave",
                  title: "Is Expired",
                  color: "red",
                  data: expiredAdditionData.value
                }
              ]
            },
            {
              parent_id: "Career",
              title: "Career",
              child: [
                {
                  child_id: "ExpiringCareer",
                  title: "Is Expiring",
                  color: "yellow",
                  data: expiringCareerData.value
                },
                {
                  child_id: "ExpiredCareer",
                  title: "Is Expired",
                  color: "red",
                  data: expiredCareerData.value
                }
              ]
            }
          ]
        }
      }
      catch(error) {
        console.log(error)
      }
    }


    onMounted(() => {
      getData()
      getExpiredEmployee()
      userCheck()
    })

    watchEffect(() => {
      // if(employeeId != 'null') {
      //   getProfile(employeeId)
      // }
    })


    const prevEmployee = reactive({
      check: false,
      list_active: null
    })
    const openEmployee = (data) => {
      // console.log("cek data employee", data)

      if(data) {
        getProfile(data.id)
        prevEmployee.check = true
        prevEmployee.list_active = data.id
      } else {
        profileData.value = {}
        prevEmployee.check = false
        prevEmployee.list_active = null
      }
    }


    const remainingModal = ref(false)
    const remainingDetail = ref({})
    const openModal = (type, data) => {
      // console.log("cek emit data", data)
      if(type == 'remaining') {
        remainingModal.value = true
        remainingDetail.value = data
      } else {
        remainingModal.value = false
        // remainingDetail.value =  {}
        // profileLeaveAll.value =  {}
        // profileLeaveAnnual.value = {}
        // profileLeave.value =  {}
      }
    }



    const modalDetail = reactive({
      Approved: false,
      Rejected: false,
    })
    const objectDetail = ref({})
    const openModalList = (event) => {
      modalDetail[event.type] = event.state ? event.state : false
      objectDetail.value = (event.data ? event.data : {})
    }


    const detailModal = ref(false)
    const detailData = ref({})
    const openDetail = (data) => {
      if(!remainingAllData.value || remainingAllData.value.length < 1){
        return true
      }

      if(data && remainingAllData.value) {
        detailData.value = remainingAllData.value.filter(item => item.id == data.id)[0]
        detailModal.value = true
      } else {
        detailModal.value = false
        detailData.value = {}
      }
    }




    const router = useRouter()
    const notifClick = (id) => {
      router.push('/leave-request?leave=' + id)
    }

    return {
      // Check Role User
      userRole,
      checkUser,
      userCheck,
      // Expired Employee
      getExpiredEmployee,
      expiredEmployeeData,
      expiringEmployeeData,
      expiredDocumentData,
      expiringDocumentData,
      expiredAdditionData,
      expiringAdditionData,
      expiringCareerData,
      expiredCareerData,

      notifClick,
      router,
      roles,
      mdiCheckBold,
      mdiPlusCircleOutline,
      mdiClose,
      titleStack,
      darkMode,
      isLoading,
      userLogin,
      usernameLogin,
      schoolidentity,
      getData,
      profileData,
      profileLeaveAll,
      profileLeaveAnnual,
      profileLeave,
      historyData,
      remainingData,
      remainingChild,
      listTodayData,
      listEmployeeRetirement,
      waitingData,
      acceptData,
      rejectData,
      remainingAllData,
      remainingModal,
      openModal,
      remainingDetail,
      modalDetail,
      objectDetail,
      openModalList,
      formatDate,
      detailModal,
      detailData,
      openDetail,
      groupPanel,
      prevEmployee,
      openEmployee
    }
  },
  methods: {
  }
}
</script>

<style>
.full-page-container {
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px;
  transition: width 1s;
}

.dashboard-container {
  background-color: white;
  padding: 15px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);
}

.outstanding-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cutoff-container {
  display: flex;
}

.cutoff {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 50px;
}

.cutoff label {
  width: fit-content;
  white-space: nowrap;
}

.cutoff label .dp__main.dp__theme_light div[aria-label="Datepicker input"] .dp__input_wrap input.dp__input {
  border-bottom: 0 solid !important;
  box-shadow: 0px 1px 2px #f67638 !important;
  border: 1px solid #f67638;
}

.category-container {
  display: grid;
  font-weight: bold;
  grid-template-columns: auto auto;
  gap: 45px;
  margin: 1rem 0;
  /* border-bottom: 1.25px solid #1c3677; */
}

.select-box {
  display: flex;
  justify-content: space-between;
}

.category-container .select-box div.flex label.checkbox span.check {
  border: 1px solid #f67638;
  margin-right: 3px;
  border-radius: 50%;
}

.category-container .select-box div.flex label.checkbox input[type="checkbox"]:checked+.check {
  background-image: none !important;
}

.category-container .select-box div.flex label.checkbox input[type="checkbox"]:checked+.check,
.radio input[type="radio"]:checked+.check {
  background-color: #56b534;
  background-position: center;
  background-repeat: no-repeat;
}

hr.divider {
  border-color: #1c3677;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  border-width: 1px;
}

.payment-box {
  background: #c9fad3 !important;
  color: black !important;
  border: 2px solid #56b534;
}

.payment-box div.flex-1 {
  padding: 5px 10px;
}

.payment-box div.flex-1 div {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}

.payment-box div.flex-1 div div div div div {
  flex-direction: column-reverse;
}

.payment-box div.flex-1 div div div div p {
  font-size: 14px;
  margin-top: 0 !important;
}

.payment-box div.flex-1 div div div div h4 {
  font-weight: 600 !important;
}

.payment-box div.flex-1 div div div {
  flex-direction: column-reverse;
}

.payment-box div.flex-1 div.justify-between div.flex.items-center.justify-center.mb-6 {
  width: 100% !important;
}

.payment-box div.flex-1 div.justify-between div.flex.items-center.justify-center.mb-6 div.justify-start.items-center.block {
  width: 100% !important;
  padding-bottom: 10px;
  border-bottom: 2px solid #56b534;
}

.payment-box div.flex-1 div div div p {
  font-size: 14px;
  margin-top: 10px !important;
}

.payment-box div.flex-1 div div div h4 {
  font-weight: 600 !important;
}

.invoice-box {
  background: white !important;
  color: black !important;
  border: 2px solid black;
}

.invoice-box div.flex-1 {
  padding: 5px 10px;
}

.invoice-box div.flex-1 div {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}

.invoice-box div.flex-1 div div div div div {
  flex-direction: column-reverse;
}

.invoice-box div.flex-1 div div div div p {
  font-size: 14px;
  margin-top: 0 !important;
}

.invoice-box div.flex-1 div div div div h4 {
  font-weight: 600 !important;
}

.invoice-box div.flex-1 div div div {
  flex-direction: column-reverse;
}

.invoice-box div.flex-1 div.justify-between div.flex.items-center.justify-center.mb-6 {
  width: 100% !important;
}

.invoice-box div.flex-1 div.justify-between div.flex.items-center.justify-center.mb-6 div.justify-start.items-center.block {
  width: 100% !important;
  padding-bottom: 10px;
  border-bottom: 2px solid black;
}

.invoice-box div.flex-1 div div div p {
  font-size: 14px;
  margin-top: 10px !important;
}

.invoice-box div.flex-1 div div div h4 {
  font-weight: 600 !important;
}

.debtors-container {
  overflow-y: auto;
  max-height: 550px;
}

.debtors-container::-webkit-scrollbar {
  width: 0;
}

.debtors-container div.transition-shadow {
  background: #ffeeee;
  border: 2px solid #eb2929;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  margin-bottom: 15px;
}

.debtors-container div.transition-shadow div.flex-1 {
  padding: 5px 10px;
}

.debtors-container div.transition-shadow div.flex-1 div.block {
  display: flex;
  justify-content: left;
}

.date-picker div[aria-label="Datepicker input"] div.dp__input_wrap input.dp__pointer {
  background: white;
  border: 1px solid #f67638;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  padding: 3px;
  padding-left: 35px;
  border-radius: 0px;
}

.rate-container {
  background: white;
  padding: 15px;
  margin-top: 30px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);
}

.input-rate div.mb-6 div div.grid div.form-comp input[type="number"] {
  border: 1px solid #f67638;
}
</style>
